import { type FunctionComponent } from 'react'
import * as React from 'react'

import { type TrackingEventName } from 'shared/experiments/consts'

const Track: FunctionComponent<ComponentProps> = ({
  event,
  data,
  children,
}) => {
  return (
    <div data-tracking-event={event} data-tracking-data={JSON.stringify(data)}>
      {children}
    </div>
  )
}

type ComponentProps = {
  event: TrackingEventName
  children: React.ReactNode
  data?: Record<string, unknown> | null
}

export default Track
